// extracted by mini-css-extract-plugin
export var container = "tabs-module--container--H8Oar";
export var list = "tabs-module--list--GtDma";
export var tab = "tabs-module--tab--qiM4w";